module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$route.params.area === 'user-meta') ? _c('user-meta') : (this.$route.params.area === 'big-idea') ? _c('big-idea') : (this.$route.params.area === 'focus-areas') ? _c('focus-areas') : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af2ed8f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EditProfile.vue
// module id = 730
// module chunks = 1